export const TABLET = '@media screen and (max-width: 1024px)'
export const MOBILE = '@media screen and (max-width: 561px)'
export const HEIGHT = '@media screen and (max-height: 524px)'
